<template>
  <div class="base-button">
    <button
      v-if="isActive"
      type="button"
      class="btn is-active-button"
      :disabled="disabled"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-bs-custom-class="custom-tooltip"
      :title="tooltipLabel"
      ref="info"
    >
      <span class="text-content">{{ activeLabel }}</span>
    </button>
    <button
      v-else-if="label != ''"
      type="button"
      :class="`btn btn-${variant}`"
      :disabled="disabled"
      @click="$emit('on-click')"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-bs-custom-class="custom-tooltip"
      :title="tooltipLabel"
      ref="info"
    >
      <slot name="prepend"> </slot>
      <span class="text-content">{{ label }}</span>
      <slot name="append"> </slot>
    </button>
    <button
      v-else
      :disabled="disabled"
      type="button"
      class="btn icon-button"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-bs-custom-class="custom-tooltip"
      @click="$emit('on-click')"
      :title="tooltipLabel"
      ref="info"
    >
      <slot name="prepend"> </slot>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { Tooltip } from 'bootstrap';

interface Props {
  label?: string;
  tooltipLabel?: string;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link';
  disabled?: boolean;
  isActive?: boolean;
  activeLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
  tooltipLabel: '',
  activeLabel: '',
  variant: 'primary',
  isActive: false,
  disabled: false,
});

defineEmits(['on-click']);

const info = ref(null);
let infoTooltip: Tooltip | undefined;

onMounted(() => {
  infoTooltip = new Tooltip(info.value!);
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/button.scss';
</style>
